<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>答疑区</h2>
				<el-button size="medium" plain type="success" id='btn_add' @click="dialogBannerVisible = true,clearform()">新增</el-button>
			</el-header>
			<el-main>
				<!-- 表格 -->
				<el-table :data="tableData" style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
					<el-table-column label="" width="60">
						<template slot-scope="scope">
							<div v-text="scope.$index+1"></div>
						</template>
					</el-table-column>
					<el-table-column width="60" prop="sort" label="排序" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="发布状态" width="80">
						<template slot-scope="scope">
							<div v-if="scope.row.fabu==1" style="color:#67C23A;">已发布</div>
							<div v-if="scope.row.fabu!=1" style="color:#d00;">未发布</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="标题"></el-table-column>
					<el-table-column width="150" prop="author" label="作者"></el-table-column>
					<el-table-column label="简介">
						<template slot-scope="scope">
							<div v-html="scope.row.profile"></div>
						</template>
					</el-table-column>
					<el-table-column width="170" prop="src" label="图标">
						<template slot-scope="scope">
							<img class="showimg" :src="scope.row.imgurl" alt="">
						</template>
					</el-table-column>
					<!--<el-table-column width="100" prop="visitcount" label="浏览次数" :show-overflow-tooltip="true"></el-table-column>-->
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row),dialogBannerVisible = true">编辑</el-button>
								<el-button size="mini" plain type="danger" @click="handleDelete(tableData, scope.row,scope.$index)">删除</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>

			</el-main>
			<el-footer>
				<el-pagination @current-change="handlelessonsChange" :current-page.sync="lessonsPage" background :page-size="9" layout="prev, pager, next, jumper" :total="pageTolessons">
				</el-pagination>
				<!--<div>
					Copyright &copy; Soren经济学人 技术支持 ：
					<a href="http://www.sdxingao.com.cn">山东兴奥</a>
				</div>-->
			</el-footer>
		</el-container>
		<el-dialog title="文章编辑" :visible.sync="dialogBannerVisible" width="900px">
			<el-form :model="ques_param">
				<el-form-item label="序号" :label-width="formLabelWidth">
					<el-input v-model="ques_param.sort" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="标题" :label-width="formLabelWidth">
					<el-input v-model="ques_param.title" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="作者" :label-width="formLabelWidth">
					<el-input v-model="ques_param.author" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="发布状态" :label-width="formLabelWidth">
					<el-switch v-model="ques_param.fabu" active-color="#13ce66" inactive-color="#ff4949" active-text="发布" active-value="1" inactive-value="0">
					</el-switch>
				</el-form-item>
				<el-form-item label="图片" :label-width="formLabelWidth">
					<el-upload class="avatar-uploader" :action="UploadUrl()" :http-request='submitLogoUpload' :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="ques_param.imgurl" :src="ques_param.imgurl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="简介" :label-width="formLabelWidth">
					<vue-editor v-model="ques_param.profile" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="customToolbar2"></vue-editor>
				</el-form-item>
				<el-form-item label="正文" :label-width="formLabelWidth">
					<!--<vue-editor v-model="ques_param.content" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="customToolbar"></vue-editor>-->
					<el-input v-model="ques_param.content" auto-complete="off"></el-input>
				</el-form-item>
				<!--<el-form-item label="浏览数" :label-width="formLabelWidth">
					<el-input v-model="ques_param.visitcount" auto-complete="off"></el-input>
				</el-form-item>-->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogBannerVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogBannerVisible = false,saveClassify()">确 定</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>
<script>
	import { VueEditor } from "vue2-editor";
	export default {
		data() {
			return {
				activeIndex: "10",
				pageTolessons: 0,
				lessonsPage:1,
				tableData: [],
				formLabelWidth: "150px",
				dialogBannerVisible: false,
				ques_param: {
					'id': '',
					'title': '', //标题
					'author': '', //作者
					'sort': '', //序列
					'fabu': '', //是否发布
					'imgurl': '', //图片地址
					'profile': '', //简介
					'content': '', //正文内容
					'visitcount': 0
				},
				customToolbar: [
					["bold", "italic", "underline", "strike"],
					["image", 'link'],
					[{
						color: []
					}, {
						background: []
					}],
					[{
						font: []
					}],
					[{
						align: []
					}],
					[{
						header: 1
					}, {
						header: 2
					}],
					[{
						header: [1, 2, 3, 4, 5, 6, false]
					}],
					[{
						size: ["small", false, "large", "huge"]
					}]
				],
				customToolbar2: [
					["bold", "italic", "underline", "strike"],
					[ 'link'],
					[{
						color: []
					}, {
						background: []
					}],
					[{
						font: []
					}],
					[{
						align: []
					}],
					[{
						header: 1
					}, {
						header: 2
					}],
					[{
						header: [1, 2, 3, 4, 5, 6, false]
					}],
					[{
						size: ["small", false, "large", "huge"]
					}]
				],
			};
		},
		components: {
			VueEditor
		},
		created() {
			this.getData();
		},
		updated: function() {
			this.ifHavemark();
		},
		methods: {
			// 页面 表格数据 初始化
			getData() {
				var self = this;
				self.axios.post("/dayi/list", {
						page:self.lessonsPage
					})
					.then(function(response) {
						console.log(response.data)
						if(response.data.code == "600") {
							self.tableData = response.data.data;
							self.pageTolessons = response.data.dataTotal;

						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							self.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			handlelessonsChange(val) {
				var self = this;
				// console.log(`当前页: ${val}`);
				self.lessonsPage = val;
				self.getData();
			},
			UploadUrl: function() {
				//return "https://snow.qdxingao.com/file/uploadLogo";
				return "https://console.sorenenglish.com/api/file/uploadLogo";
			},
			submitLogoUpload(content) {
				console.log(content);
				var self = this;
				//1. 创建formData 利用AXIOS传递
				let formData = new FormData();
				formData.append("file", content.file);
				let config = {
					"Content-Type": "multipart/form-data"
				};
				let var_this = this;
				self.axios.post("/file/uploadLogo", formData, config)
					.then(function(response) {
						//console.log(response);
						self.ques_param.imgurl = response.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//form 表单 数据
			saveClassify() {
				var self = this;
				self.axios.post("/dayi/add", self.ques_param)
					.then(function(response) {
						console.log(response);
						if(response.data.code == "600") {
							self.$message({
								message: "添加/编辑成功",
								type: "success"
							});
							self.getData();
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							self.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			clearform() {
				var self = this;
				self.ques_param = {
					'id': '',
					'title': '', //标题
					'author': '', //作者
					'sort': '', //序列
					'fabu': '', //是否发布
					'imgurl': '', //图片地址
					'profile': '', //简介
					'content': '', //正文内容
					'visitcount': 0
				}
			},
			handleEdit(index, row) {
				var that = this;
				that.ques_param = {
					'id': row.id,
					'title': row.title,
					'author': row.author,
					'sort': row.sort,
					'fabu': row.fabu,
					'imgurl': row.imgurl,
					'profile': row.profile,
					'content': row.content,
					'visitcount': row.visitcount
				}
			},
			handleAvatarSuccess(res, file) {
				console.log(res, file);
				this.ques_param.imgurl = res.data;
			},
			beforeAvatarUpload: function(file) {
				var that = this;
				const isJPG = file.type === 'image/jpeg';
				const isGIF = file.type === 'image/gif';
				const isPNG = file.type === 'image/png';
				const isBMP = file.type === 'image/bmp';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if(!isJPG && !isGIF && !isPNG && !isBMP) {
					that.$message({
						message: '上传图片必须是JPG/GIF/PNG/BMP 格式!',
						type: 'warning'
					});
				}
				if(!isLt2M) {
					that.$message({
						message: '上传图片大小不能超过 2MB!',
						type: 'warning'
					});
				}
				return(isJPG || isBMP || isGIF || isPNG) && isLt2M;
			},
			handleDelete(rows, row, index) {
				var self = this;
				self.$confirm("确认删除该文章?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.axios.post("/dayi/delete", {
								id: row.id
							})
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "删除成功",
										type: "success"
									});
									self.getData();
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								} else {
									self.ifLogin();
								}

							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						self.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			},
			handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
				var self = this;
				//1. 创建formData 利用AXIOS传递
				let formData = new FormData();
				formData.append("file", file);
				let config = {
					"Content-Type": "multipart/form-data"
				};
				let var_this = this;
				self.axios.post("/file/uploadLogo", formData, config)
					.then(function(result) {
						console.log(result);
						let url = result.data.data; // Get url from response

						Editor.insertEmbed(cursorLocation, "image", url);
						resetUploader();
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.el-footer .el-pagination{
		height:40px;
		overflow:hidden;
		padding-top:15px;
	}
	.showimg {
		width: 150px;
		height: 120px;
		object-fit: cover;
	}

	.el-header {
		position: relative;
	}

	.el-header h2 {
		margin: 0;
		line-height: 60px;
	}

	.el-header #btn_add {
		position: absolute;
		right: 25px;
		top: 12px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #67c23a;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px !important;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: auto;
		display: block;
	}

	.Saveid {
		cursor: pointer;
		color: #67c23a;
		display: block;
	}

	.menupart {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		position: relative;
	}

	.menupart img {
		display: block;
		max-width: 60%;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
	}

	.edit_bg {
		display: inline-block;
		width: 80px;
	}
</style>



// WEBPACK FOOTER //
// src/components/QuesPage.vue